import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tender } from '../../models';

@Component({
    selector: 'jft-create-tender',
    templateUrl: './create-tender.component.html',
    styleUrls: ['./create-tender.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateTenderComponent implements OnInit {

    public tender: Tender;

    public detailsLink: string = '';
    public contractsLink: string = '';
    public suppliersLink: string = '';
    public reviewLink : string = '';

    constructor(
        private route: ActivatedRoute
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.tender = data['tender'] as Tender;


    }

}
